module.exports = __webpack_public_path__ + "img/dashboard.a6fbbd.svg";